import { useContext } from "react"
import { EmissoesParaMeuCNPJContext } from "./EmissoesParaMeuCNPJContext"

export function useEmissoesParaMeuCNPJContext() {
    return useContext(EmissoesParaMeuCNPJContext)
}
